import React from "react";
import { Link } from "react-router-dom";
import { Star, ChatCircle, Heart, Camera, Calendar, Trophy, Info } from "@phosphor-icons/react";

const ACTIONS = [
  { icon: Star, label: "Avaliar um mangá", xp: 1, note: "Apenas uma vez por mangá" },
  { icon: Heart, label: "Dar like numa notícia", xp: 1, note: "Uma vez por notícia" },
  { icon: ChatCircle, label: "Comentar uma notícia", xp: 1, note: "Por cada comentário" },
  { icon: Heart, label: "Dar like num próximo lançamento", xp: 1, note: "Uma vez por lançamento" },
  { icon: ChatCircle, label: "Comentar um próximo lançamento", xp: 1, note: "Por cada comentário" },
  { icon: Heart, label: "Dar like num evento", xp: 1, note: "Uma vez por evento" },
  { icon: ChatCircle, label: "Comentar um evento", xp: 1, note: "Por cada comentário" },
  { icon: Camera, label: "Adicionar avatar pela primeira vez", xp: 1, note: "Uma única vez" },
  { icon: Calendar, label: "Login diário", xp: 1, note: "Uma vez por dia" },
];

export default function HowToEarnPoints() {
  return (
    <div className="pt-20 max-w-4xl mx-auto px-5 lg:px-8 pb-24" data-testid="how-to-earn-page">
      <div className="mb-8">
        <div className="font-mono-accent text-xs text-[#E63946] mb-2 flex items-center gap-2">
          <Info size={14} weight="bold" /> COMO GANHAR PONTOS
        </div>
        <h1 className="font-display text-4xl lg:text-5xl font-extrabold tracking-tight">Sistema de XP</h1>
        <p className="text-zinc-400 mt-2">Ganha XP a cada ação e sobe de nível para desbloquear títulos, banners exclusivos e conquistas.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-3 mb-10">
        {ACTIONS.map((a, i) => (
          <div key={i} className="flex items-center gap-4 bg-[#0f0f14] border border-white/5 rounded-xl p-4" data-testid={`xp-action-${i}`}>
            <div className="w-11 h-11 rounded-lg bg-[#E63946]/15 text-[#E63946] grid place-items-center flex-shrink-0">
              <a.icon size={22} weight="fill" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-display font-semibold">{a.label}</div>
              <div className="text-[11px] text-zinc-500 mt-0.5">{a.note}</div>
            </div>
            <div className="text-right flex-shrink-0">
              <div className="font-display font-black text-lg text-emerald-400">+{a.xp}</div>
              <div className="text-[10px] text-zinc-500 font-mono-accent">XP</div>
            </div>
          </div>
        ))}
      </div>

      <div className="rounded-2xl border border-[#E63946]/30 bg-gradient-to-br from-[#1a0810] via-[#0f0f14] to-[#180818] p-6 mb-8">
        <div className="flex items-center gap-2 mb-3">
          <Trophy size={20} weight="fill" className="text-[#F59E0B]" />
          <h2 className="font-display font-extrabold text-xl">Como Funcionam os Níveis</h2>
        </div>
        <p className="text-zinc-300 leading-relaxed">
          Começas no <span className="font-bold text-white">Nível 1 com 0 XP</span>. Para subires de nível, a XP necessária <span className="font-bold text-[#E63946]">duplica sempre</span>.
        </p>
        <div className="mt-4 grid grid-cols-2 md:grid-cols-4 gap-2 text-sm">
          {[
            { l: "Nível 1 → 2", xp: 3 }, { l: "Nível 2 → 3", xp: 6 },
            { l: "Nível 3 → 4", xp: 12 }, { l: "Nível 4 → 5", xp: 24 },
            { l: "Nível 5 → 6", xp: 48 }, { l: "Nível 6 → 7", xp: 96 },
            { l: "Nível 7 → 8", xp: 192 }, { l: "Nível 8 → 9", xp: 384 },
          ].map(row => (
            <div key={row.l} className="bg-black/30 rounded-lg p-3 text-center border border-white/5">
              <div className="text-[10px] font-mono-accent text-zinc-500">{row.l}</div>
              <div className="font-display font-bold text-lg text-[#E63946]">{row.xp} XP</div>
            </div>
          ))}
        </div>
        <p className="text-xs text-zinc-500 mt-4">A XP restante ao subir de nível transfere-se para o próximo. Ex: se estás no Nível 2 (4/6) e ganhas 3 XP, ficas no Nível 3 com 1/12 XP.</p>
      </div>

      <div className="rounded-2xl border border-[#7209B7]/30 bg-gradient-to-br from-[#150822] via-[#0f0f14] to-[#180818] p-6">
        <h2 className="font-display font-extrabold text-xl mb-3">Títulos por Nível</h2>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-2 text-center">
          {[
            { n: "Genin", lvl: "1 - 19" },
            { n: "Chunin", lvl: "20 - 49" },
            { n: "Jonin", lvl: "50 - 99" },
            { n: "Kage", lvl: "100 - 199" },
            { n: "Sannin", lvl: "200+" },
          ].map(t => (
            <div key={t.n} className="bg-black/30 rounded-lg p-3 border border-white/5">
              <div className="font-display font-black text-[#E63946]">{t.n}</div>
              <div className="text-[10px] font-mono-accent text-zinc-500">NV {t.lvl}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-8 text-center">
        <Link to="/ranking" className="inline-block btn-crimson px-6 py-3 rounded-lg font-display font-bold">Ver Ranking →</Link>
      </div>
    </div>
  );
}
